import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './fehlerart.list-view.html',
    styleUrls: ['./fehlerart.list-view.scss']
})
export class FehlerartListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
